import { useContext, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getComplexResourceGroups } from 'redux/selectors/experience';
import DrawerLayout from '../drawer_layout';
import { ExperienceContext } from '../helpers';

const ComplexReturnFerry = () => {
  const history = useHistory();
  const { setReturnFerry, needUserSelect, setNeedUserSelect } =
    useContext(ExperienceContext);
  const returnFerries = useSelector((state) =>
    getComplexResourceGroups(state, {
      productType: 'ferry',
      journeyType: 'return',
    })
  );
  const hasData = Boolean(returnFerries.length);

  useEffect(() => {
    setNeedUserSelect((prevState) => ({
      ...prevState,
      returnFerries: hasData,
    }));
  }, [setNeedUserSelect, hasData]);

  // Redirect to next page if there is no return ferry
  if (!hasData) {
    setTimeout(() => history.push('/complex/departure-coach'));

    return null;
  }

  // Assume there is only 1 return ferry
  const firstOption = returnFerries[0].options[0];

  return (
    <DrawerLayout
      back={needUserSelect.departureFerry}
      productName={returnFerries[0].title}
    >
      <h1>ComplexReturnFerry</h1>
      <h5 className="fw-bold my-4">{firstOption.title}</h5>
      {firstOption.package_options.options.map((ferry) => (
        <Card className="booking-option-card my-4" key={ferry.name}>
          <Card.Body>
            <Card.Title className="title-wrap">
              <h5 className="reset-text fw-bold mb-2 text-secondary">
                {ferry.name}
              </h5>
            </Card.Title>
            <div className="mt-3">
              <button
                type="button"
                onClick={() => {
                  setReturnFerry({
                    groupId: firstOption.groupId,
                    packageId: firstOption.packageId,
                    value: ferry.id,
                  });
                  setTimeout(() => history.push('/complex/departure-coach'));
                }}
                className="btn btn-primary w-100"
              >
                Select
              </button>
            </div>
          </Card.Body>
        </Card>
      ))}
    </DrawerLayout>
  );
};

export default ComplexReturnFerry;
